import { transition } from '@helpers/animate';
import { imageCoverContainer, imageWrapperPreserveRatio } from '@helpers/aspectRatio';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { baseGrid } from '@helpers/grid';
import { Device, from } from '@helpers/media';
import { contentStyles, h2 } from '@helpers/typography';
import { ButtonStyles } from '@stories/Components/Buttons/GeneralButton/Button.styles';
import SectionWrapper from '@stories/Components/Global/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/Global/SectionWrapper/SectionWrapper.styles';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  position: relative;
  overflow: hidden;

  &[data-content-variant='light'] {
    background-color: ${brand.primary.purple};
  }

  &[data-content-variant='dark'] {
    background-color: ${brand.primary.offWhite};
  }

  &[data-bg-graphic='true'] {
    ${SectionWrapperStyles.Inner} {
      padding-bottom: calc(var(--sectionSpacingBottom) * 2);
    }

    ${SectionWrapperStyles.SiteWide} > svg {
      ${transition('transform', 0.6)};

      position: absolute;
      bottom: 0;
      left: 0;
      width: 90%;
      color: ${brand.tertiary.darkBlue};
      transform: translate(-15%, 20%);
    }

    &[data-animate='true'] {
      ${SectionWrapperStyles.SiteWide} > svg {
        transform: translate(-10%, 20%);
      }
    }
  }

  ${SectionWrapperStyles.SiteWide} {
    ${baseGrid};
  }
`;
const ContentWrapper = styled.div `
  grid-column: 1 / span 12;
  display: flex;
  background-color: var(--bgColour);
  align-items: center;
  flex-direction: column;
  position: relative;

  &[data-variant='light'] {
    --bgColour: ${brand.primary.offWhite};
    --bgColourTint: ${brand.tint.offWhite};
    --fgColour: ${brand.primary.purple};
    --fgColourTint: ${brand.tint.purple};
  }

  &[data-variant='dark'] {
    --bgColour: ${brand.primary.purple};
    --bgColourTint: ${brand.tint.purple};
    --fgColour: ${brand.primary.offWhite};
    --fgColourTint: ${brand.tint.offWhite};
  }

  @media ${from(Device.MobileLarge)} {
    flex-direction: row;
  }

  @media ${from(Device.Desktop)} {
    grid-column: 2 / span 10;
  }
`;
const ContentContainer = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${fluid(12, 16)};
  flex: 1;
  padding: ${fluid(38, 64)} ${fluid(18, 148)};

  ${ButtonStyles.Button} {
    margin: ${fluid(12, 14)} 0 0;
  }
`;
const Title = styled.h2 `
  ${h2};

  color: var(--fgColour);
  margin: 0;
`;
const Content = styled.div `
  ${contentStyles};

  color: var(--fgColour);
`;
const ImageWrapper = styled.div `
  width: 100%;
  background-color: var(--fgColour);

  @media ${from(Device.MobileLarge)} {
    width: 40%;
    height: 100%;

    &[data-align='left'] {
      order: -1;
    }
  }
`;
const ImageContainer = styled.div `
  ${imageWrapperPreserveRatio(339, 273)};

  @media ${from(Device.MobileLarge)} {
    height: 100%;
    padding: 0;
  }
`;
const Image = styled.img `
  ${imageCoverContainer()};
`;
const SignpostSplitContentStyles = {
    Container,
    ContentWrapper,
    Title,
    ContentContainer,
    Content,
    ImageWrapper,
    ImageContainer,
    Image,
};
export default SignpostSplitContentStyles;
